import solcentreApiClient from '@/http/axios';

export default {
  get(url) {
    return solcentreApiClient.get(url);
  },

  post(url, data, option) {
    return solcentreApiClient.post(url, data, option);
  },

  put(url, data) {
    return solcentreApiClient.put(url, data);
  },

  del(url) {
    return solcentreApiClient.delete(url);
  },
};
